





















































































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import MatchMultipleProductPrincipalAccordionTable from "@/components/Agents/MatchMultipleProductPrincipalAccordionTable.vue";
import ProductMixin, {
  AgentProductMixinTags,
} from "@/mixins/http/Agents/Product";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ToastInvoker from "@/utils/ToastInvoker";
import MultipleProduct from "@/models/Agents/MultipleProduct";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { AgentModuleConfiguration } from "@/models";
import { NotificationBadgeGroups } from "@/components/Agents/NotificationBadge.vue";
@Component({
  components: {
    MatchMultipleProductPrincipalAccordionTable,
    MultiLevelSelect,
  },
})
export default class MatchMultipleProductSelectPrincipalAccordion extends Mixins(
  ProductMixin
) {
  @Prop() readonly multipleProductsGroupName!: string;
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  @Action("notificationsGroups/reload")
  readonly reloadNotificationForGroup!: (
    group: NotificationBadgeGroups
  ) => void;

  loading = false;
  state: "opened" | "closed" = "closed";
  selectedProductId: string | null = null;
  selectedCompanyId: string | null = null;
  multipleProductsGroup: MultipleProduct[] = [];
  options: any[] = [];
  sameProductAnswer: boolean | null = null; // null means: still to answer
  resolved = false;

  @Watch("selectedProductId")
  onProductIdChanged(value: number) {
    const selectedProduct = this.multipleProductsGroup.find(
      (product) => product.id === value
    );

    if (!selectedProduct) return;

    this.selectedCompanyId = selectedProduct.agentCompanyId;
  }

  async toggleState() {
    if (this.isResolved()) return;

    if (this.state == "opened" && !this.resolved) {
      this.state = "closed";
      this.sameProductAnswer = null;
      return;
    }

    this.state = "opened";
    this.loading = true;

    try {
      this.multipleProductsGroup = await this.getMultipleProductsGroupByName(
        this.profile.slug,
        {
          group_name: this.multipleProductsGroupName,
        }
      );

      this.options = this.multipleProductsGroup.map((product) => {
        return {
          id: product.id,
          text: product.id,
        };
      });
    } catch (error) {
      ToastInvoker.errorToast(
        "Errore durante il caricamento dei prodotti.",
        error
      );
    } finally {
      this.loading = false;
    }
  }

  onSameProductAnswer() {
    this.sameProductAnswer = true;
  }

  async onDifferentProductAnswer() {
    this.sameProductAnswer = false;
    try {
      await this.sendAlertMultipleProductsGroup(
        this.multipleProductsGroup.map((product) => product.id as string),
        this.profile?.slug || "",
        this.multipleProductsGroupName,
        AgentProductMixinTags.SendAlertMultipleProductsGroup
      );
      ToastInvoker.successToast(
        `Segnalazione inviata per il prodotto: ${this.multipleProductsGroupName}`,
        "top-right",
        5000
      );
      this.resolved = true;
      this.$emit("multiple-product-solved");
      this.reloadNotificationForGroup(NotificationBadgeGroups.MultipleProducts);
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il salvataggio.", error);
    } finally {
      this.loading = false;
    }
  }

  async onSave() {
    if (!this.selectedProductId) {
      ToastInvoker.errorToast("Seleziona un prodotto prima di salvare.", null);
      return;
    }
    this.loading = true;
    try {
      await this.resolveMultipleProductsGroup(
        this.multipleProductsGroup.map((product) => product.id as string),
        this.profile?.slug || "",
        this.selectedProductId as string,
        this.selectedCompanyId?.toString() as string,
        "resolve_multiple_products_group"
      );
      ToastInvoker.successToast(`Capofila scelto: ${this.selectedProductId}`);
      this.resolved = true;
      this.$emit("multiple-product-solved");
      this.reloadNotificationForGroup(NotificationBadgeGroups.MultipleProducts);
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il salvataggio.", error);
    } finally {
      this.loading = false;
    }
  }

  needAnswer() {
    return this.sameProductAnswer === null;
  }

  isSameProduct() {
    return this.sameProductAnswer === true;
  }

  isResolved() {
    return this.resolved;
  }

  hideWhenResolved() {
    return this.isResolved() ? "group-resolved" : "";
  }

  resolvedTitle() {
    return this.isResolved() ? "text-muted" : "";
  }
}
